/* ABSCENTS — carruseles de recomendaciones de la ficha (v110): barra de avance, flechas en escritorio,
   relleno de "Puede que te guste" con las recomendaciones de Shopify sin repetir y atajo a la línea. */
(function () {
  if (window.__abxRec) return;
  window.__abxRec = true;

  function idsEnPagina() {
    var s = new Set();
    document.querySelectorAll('.abx-rec [data-product-id]').forEach(function (el) { s.add(String(el.getAttribute('data-product-id'))); });
    var root = document.querySelector('[data-abx-recs-root]');
    if (root) s.add(String(root.getAttribute('data-product-id')));
    return s;
  }

  function barra(sec) {
    if (sec.__abxBar) { sec.__abxBar(); return; }
    var sc = sec.querySelector('[data-abx-scroller]');
    var th = sec.querySelector('.abx-rec__bar span');
    if (!sc || !th) return;
    function upd() {
      var max = sc.scrollWidth - sc.clientWidth;
      var vis = sc.scrollWidth ? sc.clientWidth / sc.scrollWidth : 1;
      sec.classList.toggle('abx-rec--cabe', max <= 2);
      th.style.width = Math.max(vis * 100, 10) + '%';
      var pos = max > 0 ? sc.scrollLeft / max : 0;
      th.style.transform = 'translateX(' + (pos * (100 / Math.max(vis, 0.1) - 100)) + '%)';
    }
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    sec.querySelectorAll('[data-abx-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        sc.scrollBy({ left: Number(b.getAttribute('data-abx-nav')) * sc.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
    sec.__abxBar = upd;
    upd();
  }

  function rellenar(sec) {
    var url = sec.getAttribute('data-abx-fill');
    var track = sec.querySelector('[data-abx-track]');
    if (!url || !track) return;
    var meta = Number(sec.getAttribute('data-abx-target')) || 10;
    var hay = track.querySelectorAll('[data-abx-card]').length;
    if (hay >= meta) { sec.hidden = false; barra(sec); return; }
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var vistos = idsEnPagina();
          var root = document.querySelector('[data-abx-recs-root]');
          var gen = root ? root.getAttribute('data-abx-g') : '';
          doc.querySelectorAll('[data-abx-card]').forEach(function (card) {
            if (hay >= meta) return;
            var id = String(card.getAttribute('data-product-id'));
            if (!id || vistos.has(id)) return;
            var g = card.closest('[data-abx-g]');
            if (gen && g && g.getAttribute('data-abx-g') !== gen) return;
            var isla = card.closest('is-land') || card;
            vistos.add(id);
            track.appendChild(document.importNode(isla, true));
            hay++;
          });
          if (hay && !customElements.get('product-grid-item')) {
            import('components/product-grid-item').catch(function () {});
          }
        }
        if (hay > 0) { sec.hidden = false; barra(sec); }
      })
      .catch(function () { if (hay > 0) { sec.hidden = false; barra(sec); } });
  }

  function atajo() {
    var tpl = document.querySelector('[data-abx-atajo-tpl]');
    if (!tpl || document.querySelector('.abx-atajo')) return;
    var hint = document.querySelector('.product-single__meta [data-variant-hint], [data-variant-hint]');
    if (!hint || !hint.parentElement) return;
    var a = tpl.content.firstElementChild.cloneNode(true);
    /* v117: arriba del selector de mililitros, sin línea: primero la versión, luego la medida */
    var envoltura = hint.closest('.variant-wrapper');
    if (envoltura && envoltura.parentElement) envoltura.parentElement.insertBefore(a, envoltura);
    else hint.parentElement.appendChild(a);
    a.addEventListener('click', function (e) {
      var dest = document.getElementById('abx-linea');
      if (!dest) return;
      e.preventDefault();
      dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* v112: "Sigue explorando" — pestañas La casa / La familia */
  function activar(root, cual) {
    root.querySelectorAll('[data-abx-tab]').forEach(function (t) {
      var on = t.getAttribute('data-abx-tab') === cual;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('[data-abx-panel]').forEach(function (p) {
      var on = p.getAttribute('data-abx-panel') === cual;
      p.hidden = !on;
      if (on) barra(p);
    });
  }
  function pestanas(root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-abx-tab]'));
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activar(root, t.getAttribute('data-abx-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus();
        activar(root, n.getAttribute('data-abx-tab'));
      });
    });
  }

  /* v132: init por raíz; abx-recs-lazy lo llama al insertar los carruseles que llegan bajo demanda */
  function init(raiz) {
    var r = raiz || document;
    r.querySelectorAll('[data-abx-rec]').forEach(function (sec) {
      if (sec.__abxIni) return;
      sec.__abxIni = true;
      if (sec.hasAttribute('data-abx-fill')) rellenar(sec);
      if (!sec.hidden) barra(sec);
    });
    r.querySelectorAll('[data-abx-tabs]').forEach(function (t) {
      if (t.__abxIni) return;
      t.__abxIni = true;
      pestanas(t);
    });
    atajo();
  }
  window.abxRecInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
